<template>
  <div class="option" @click="open = !open">
    <div class="header" :class="{ open }">
      <slot name="h"/>
      <open/>
    </div>
    <div v-show="open" class="inner">
      <slot/>
    </div>
  </div>
</template>

<script>
import Open from '@/assets/open.svg';

export default {
  components: { Open },
  data: () => ({
    open: false,
  }),
};
</script>

<style lang="scss" scoped>
.option {
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
  cursor: pointer;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover,
  &.open {
    font-weight: 700;
    
    svg {
      fill: #83ca54;
    }
  }

  svg {
    fill: #919191;
    transition: fill 0.3s;
    flex-shrink: 0;
  }
}

.inner {
  margin-top: 20px;
}
</style>